export default __webpack_public_path__ + "eb50524.png";